module.exports = __webpack_public_path__ + "img/4819.32a7988b.png";